var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"clearable":"","value":_vm.data,"placeholder":"请选择"},on:{"change":_vm.handleChange}},_vm._l((_vm.calcList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }